// ***Footer.tsx

import React from 'react';

export default function Footer(): React.JSX.Element {
  return (
    <footer className="w-full border-t border-mcc-lightest/50 bg-slate-50 px-6 py-8 text-sm text-mcc-darkest/80">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-6 md:flex-row">
        <p className="text-center md:text-left text-mcc-darkest/70">
          © 2026 My Connective Care LLC. All rights reserved.
        </p>

        <div className="flex flex-wrap justify-center gap-6 text-sm font-medium">
          <a href="/about#policies" className="text-mcc-darkest hover:text-mcc-neutral transition-colors">
            Privacy and Data Use Policies
          </a>
        </div>

        <div>
          <a
            href="mailto:info@myconnectivecare.com"
            className="font-medium text-mcc-neutral hover:text-mcc-darkest hover:underline transition-colors"
          >
            info@myconnectivecare.com
          </a>
        </div>
      </div>
    </footer>
  );
}
